import React, { useEffect } from "react";

export default function DeleteAccountModal({
  show,
  accepted,
  onAccepted,
  onClose,
  onConfirm,
}) {
  useEffect(() => {
    if (!show) return;

    const oldOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = oldOverflow;
    };
  }, [show]);

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="deleteAccountModalTitle"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        background: "rgba(20, 8, 12, 0.72)",
        overflowY: "auto",
        padding: "18px 12px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 620,
          margin: "0 auto",
          minHeight: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          className="shadow-lg"
          style={{
            width: "100%",
            borderRadius: 32,
            background: "#fffafa",
            overflow: "hidden",
          }}
        >
          <div className="p-4 p-md-5">

            <div className="text-center mb-4">
              <div
                className="d-inline-flex align-items-center justify-content-center mb-3"
                style={{
                  width: 86,
                  height: 86,
                  borderRadius: "50%",
                  background: "#fde8eb",
                  fontSize: 42,
                }}
              >
                🗑
              </div>

              <h2
                id="deleteAccountModalTitle"
                className="fw-bold mb-2"
                style={{
                  color: "#8b1e2d",
                  lineHeight: 1.1,
                }}
              >
                Richiedi eliminazione account
              </h2>

              <div className="fs-5 text-muted">
                Prima di procedere leggi attentamente queste informazioni.
              </div>
            </div>

            <div
              className="p-3 p-md-4 mb-3"
              style={{
                borderRadius: 24,
                border: "1px solid #ead7da",
                background: "#ffffff",
              }}
            >
              <div className="d-flex gap-3 align-items-start mb-3">

                <div className="fw-bold fs-5">
                  Prima della chiusura definitiva del tuo account ti consigliamo di:
                </div>
              </div>

              <InfoRow>
                utilizzare l'eventuale credito disponibile nel Wallet;
              </InfoRow>

              <InfoRow>
                utilizzare gli eventuali premi del programma fedeltà già maturati,
                solo se hai raggiunto i punti necessari per riscattarli;
              </InfoRow>

              <InfoRow last>
                utilizzare eventuali bonus, omaggi o crediti promozionali.
              </InfoRow>
            </div>

            <div
              className="p-3 p-md-4 mb-4"
              style={{
                borderRadius: 24,
                border: "1px solid #efb8bf",
                background: "#fff1f3",
              }}
            >
              <div className="d-flex gap-3 align-items-start">
                <div style={{ fontSize: 30 }}>⚠</div>

                <div>
                  <div
                    className="fw-bold fs-5 mb-2"
                    style={{ color: "#8b1e2d" }}
                  >
                    Dopo la chiusura definitiva dell'account
                  </div>

                  <div className="fs-5 mb-2">
                    non sarà più possibile utilizzare:
                  </div>

                  <ul className="fs-5 mb-0 ps-4">
                    <li>il Wallet;</li>
                    <li>i punti fedeltà;</li>
                    <li>gli eventuali premi riscattabili;</li>
                    <li>i bonus e i crediti promozionali;</li>
                    <li>gli altri vantaggi associati all'account.</li>
                  </ul>
                </div>
              </div>
            </div>

            <label
              className="d-flex gap-3 align-items-start p-3 mb-4"
              style={{
                borderRadius: 20,
                background: "#f5f3f3",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                className="form-check-input mt-1"
                style={{
                  width: 25,
                  height: 25,
                  flexShrink: 0,
                }}
                checked={accepted}
                onChange={(e) => onAccepted(e.target.checked)}
              />

              <span className="fw-semibold fs-5">
                Ho letto e compreso queste informazioni.
              </span>
            </label>

            <div className="fw-bold text-center fs-5 mb-3">
              Sei sicuro di voler continuare?
            </div>

            <div className="d-grid gap-3">
              <button
                type="button"
                className="btn text-white rounded-pill py-3 fw-bold fs-5"
                disabled={!accepted}
                onClick={onConfirm}
                style={{
                  background: accepted
                    ? "linear-gradient(135deg, #a5001d 0%, #760014 100%)"
                    : "#d8bcc1",
                  border: 0,
                }}
              >
                🗑 Sì, continua
              </button>

              <button
                type="button"
                className="btn btn-outline-secondary rounded-pill py-3 fw-semibold fs-5"
                onClick={onClose}
              >
                Annulla
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}

function InfoRow({ children, last = false }) {
  return (
    <div className={`d-flex gap-3 ${last ? "" : "mb-3"}`}>
      <div
        className="d-flex align-items-center justify-content-center flex-shrink-0 text-white"
        style={{
          width: 32,
          height: 32,
          borderRadius: "50%",
          background: "#d9344b",
          fontWeight: 700,
        }}
      >
        ?
      </div>

      <div className="fs-5">
        {children}
      </div>
    </div>
  );
}
